import request from '@/utils/request'
let preUrl = '/wuxingCar'

export const checkCarStatus = () => {
  return request({
    method: 'GET',
    url: `${preUrl}/checkStatus`,
  })
}
export const getCarCoupon = (parmas) => {
  return request({
    method: 'GET',
    url: `${preUrl}/getCouponInfo`,
    parmas,
  })
}

export const getCarInfo = (parmas) => {
  return request({
    method: 'GET',
    url: `${preUrl}/getCarInfo`,
    parmas,
  })
}
export const robCarCoupon = (data) => {
  return request({
    method: 'POST',
    url: `${preUrl}/rob`,
    data,
  })
}

export const checkCanReal = () => {
  return request({
    method: 'GET',
    url: 'member/checkCanReal',
  })
}
export const checkUserIsReal = () => {
  return request({
    method: 'GET',
    url: 'member/checkUserIsReal',
  })
}
export const getVerCode = (params) => {
  return request({
    method: 'GET',
    url: 'member/getVerCode',
    params,
  })
}

export const realUserInfo = (data) => {
  return request({
    method: 'POST',
    url: 'member/realUserInfo',
    data,
  })
}
